export const GOVGR_NOT_FONT_SIZE_24 = "govgr-!-font-size-24 ";
export const GOVGR_NOT_FONT_SIZE_19 = "govgr-!-font-size-19";
export const GOVGR_NOT_FONT_SIZE_14 = "govgr-!-font-size-14";
